export default {
    email: 'Email',
    phone: 'Phone',
    sms: 'SMS',
    messenger: 'Messenger',
    video: 'Video',
};
